export function getApiBase() {
  const apiBase = process.env.REACT_APP_API_BASE?.replace(/\/+$/, "");

  if (apiBase) {
    return apiBase;
  }

  if (process.env.NODE_ENV === "development") {
    return `${window.location.protocol}//${window.location.hostname}:3001`;
  }

  throw new Error("Missing REACT_APP_API_BASE for the production API.");
}
